import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"
import "intl-tel-input/build/css/intlTelInput.css"

export default class extends Controller {
  static targets = ['phone']

  connect() {
    if (this.alreadyInitialized) return

    this.alreadyInitialized = true

    this.iti = intlTelInput(this.phoneTarget, {
      initialCountry: this.getInitialCountry(),
      separateDialCode: true,
      nationalMode: true,
      onlyCountries: ['pl', 'no'],
      geoIpLookup: callback => {
        fetch("https://ipapi.co/json")
          .then(res => res.json())
          .then(data => {
            const countryCode = data?.country_code?.toLowerCase() || "pl"
            callback(countryCode)
          })
          .catch(() => callback("pl"))
      },
      hiddenInput: () => ({
        phone: 'full_phone',
        country: 'country_code'
      }),
      loadUtils: () => import('intl-tel-input/build/js/utils.js')
    })

    this.phoneTarget.addEventListener("countrychange", () => {
      const selected = this.iti.getSelectedCountryData()
      const d = new Date()
      d.setTime(d.getTime() + (1 * 60 * 60 * 1000))
      document.cookie = `country_code=${selected.iso2};expires=${d.toUTCString()};path=/;SameSite=Strict;`
    })
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
      this.iti = null
    }
  }

  getInitialCountry() {
    const cookie = document.cookie
      .split("; ")
      .find(row => row.startsWith("country_code="))
      ?.split("=")[1]

    return cookie || "auto"
  }
}
